'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';

/* ============================================================
   Helpers
   ============================================================
   Le rewrite Next.js (next.config.js) proxyfie /media/* → backend.
   On retourne les URLs relatives telles quelles — le browser
   appellera /media/... sur Next.js qui forwarde au backend.
   Les URLs absolues (CDN, S3…) sont gardées intactes.
============================================================ */
export function getFullAvatarUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return url.startsWith('/') ? url : `/${url}`;
}

/* ============================================================
   Context
============================================================ */
interface UserAvatarContextValue {
  avatarUrl: string | null;
  setAvatarUrl: (url: string | null) => void;
}

const UserAvatarContext = createContext<UserAvatarContextValue>({
  avatarUrl: null,
  setAvatarUrl: () => {},
});

export function UserAvatarProvider({
  children,
  initialUrl,
}: {
  children: React.ReactNode;
  initialUrl?: string | null;
}) {
  const [avatarUrl, setAvatarUrlRaw] = useState<string | null>(
    getFullAvatarUrl(initialUrl) ?? null,
  );

  const setAvatarUrl = useCallback((url: string | null) => {
    setAvatarUrlRaw(getFullAvatarUrl(url));
  }, []);

  return (
    <UserAvatarContext.Provider value={{ avatarUrl, setAvatarUrl }}>
      {children}
    </UserAvatarContext.Provider>
  );
}

export function useUserAvatar() {
  return useContext(UserAvatarContext);
}